const isErwachsenenTheater = (typ) => typ === 'Erwachsenentheater'

export const getTheaterTypColor = (typ) => {
  return isErwachsenenTheater(typ) ? '#5c0020' : '#ee964b'
}

export const getTheaterTypEmoji = (typ) => {
  return isErwachsenenTheater(typ) ? '🎭' : '🧒'
}
